import React from "react";
import { Link } from "@/components/common/Link";
const sectors = [{
  name: "Construcción",
  path: "/CatalogPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sector_automotriz.png",
  pathClassName: "aspect-square overflow-hidden rounded-lg bg-muted !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.23.54-p.m.png)]"
}, {
  name: "Herrería",
  path: "/CatalogPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sector_construccion.png",
  pathClassName: "aspect-square overflow-hidden rounded-lg bg-muted !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.24.03-p.m.png)] aspect-square overflow-hidden rounded-lg bg-muted !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.25.50-p.m.png)]"
}, {
  name: "Estructura",
  path: "/CatalogPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sector_energia.png",
  pathClassName: "aspect-square overflow-hidden rounded-lg bg-muted !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.24.10-p.m.png)]"
}, {
  name: "Manufactura",
  path: "/CatalogPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sector_manufactura.png",
  pathClassName: "aspect-square overflow-hidden rounded-lg bg-muted !bg-[url(https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.24.15-p.m.png)]"
}];
export default function SectoresServidos() {
  return <section id="sectores-servidos" className="py-20 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center">
          
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-center mb-12 text-primary">Sectores Que A<span className="text-primary" data-ast-id="f:/src/pages/KalischSteel/sections/SectoresServidos.tsx|sig:p8yc2l" data-ast-start="2063" data-ast-end="2110">tendemos</span></h2>

          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {sectors.map((sector, i) => <Link key={i} to={sector.path} data-index={i} className="group flex flex-col space-y-4">
                <div className={`${sector.pathClassName || ""} aspect-square overflow-hidden rounded-lg bg-muted`}>
                  
                </div>
                <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors text-center">
                  {sector.name}
                </h3>
              </Link>)}
          </div>

        </div>
      </div>
    </section>;
}